__turbopack_context__.v({
  "container": "MaLjlW_container",
  "hide": "MaLjlW_hide",
  "light": "MaLjlW_light",
  "loader": "MaLjlW_loader",
  "lottie": "MaLjlW_lottie",
  "medium": "MaLjlW_medium",
  "shimmer": "MaLjlW_shimmer",
  "solid": "MaLjlW_solid",
  "spin": "MaLjlW_spin",
  "text-bar-sweep": "MaLjlW_text-bar-sweep",
  "transparent": "MaLjlW_transparent",
});
